<template>
    <div>

        <div class="modal fade" id="announcement-view-modal" tabindex="-1" aria-labelledby="announcement-view-modal" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header rounded-bottom-0 py-3 px-4 bg-primary">
                        <div>
                            <p class="text-lg mb-0 fw-semibold">
                                Mededeling
                            </p>
                        </div>
                        <button @click="hideModal()" type="button" class="btn-close mb-0 me-0"></button>
                    </div>
                    <div class="ps-4 pe-4">
                        <div class="modal-icon text-center mt-2">
                            <span class="round-icon bg-lightyellow">
                                <i class="fa fa-bell text-primary" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="modal-body text-center">
                            <h2 class="text-font fw-semibold mb-2 h3">
                                {{ this.announcement.title}}
                            </h2>
                            <p class="text-lightgrey">{{ this.announcement.time_diff }}</p>
                            <p class="text-lightgrey text-lg fw-medium mb-0" v-html="this.announcement.description"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import {EventBus} from "../../../event-bus";

export default {
    name: 'announcement-view-modal',
    components: {},
    props: {},
    data() {
        return {
            announcement: {
                id: '',
                title: '',
                date: '',
                time_diff: '',
                description: '',
                viewed_at: '',
            }
        }
    },
    computed: {},
    watch: {},
    methods: {
        hideModal() {
            axios.post('api/user-announcement-has-been-read', {
                announcementId: this.announcement.id,
            })
                .then(response => {
                    if (response.data.status === 422) {
                        this.announcementModal.hide();
                        throw [true, response.data.message];
                    }

                    EventBus.$emit('refetchAnnouncements');

                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het opslaan van de gegevens.", "error");
                });

            this.announcementModal.hide();
        },
    },
    mounted() {
        this.announcementModal = new bootstrap.Modal(document.getElementById('announcement-view-modal'));

        EventBus.$on('showAnnouncementViewModal', (announcement) => {
            this.announcement = announcement;
            this.announcementModal.show();
        });
    },
    created() {},
}
</script>
